export const INVOICE_TRANSITIONS = {
  // Step transitions in editor
  step: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.2 }
  },

  // Customer selection reveals
  customerSelection: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.2 }
  },

  // Customer selection with delay
  customerSelectionDelayed: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.2, delay: 0.1 }
  },

  // Line item editor overlay
  editorOverlay: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.15 }
  },

  // Line item editor container
  editorContainer: {
    initial: { opacity: 0, scale: 0.98 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.2, ease: 'easeOut' }
  },

  // Checkbox content reveals - smooth gradual fade
  checkboxContent: {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.25,
      ease: 'easeInOut'
    }
  }
} as const

// Shared styles
export const OVERLAY_STYLE = {
  position: 'absolute' as const,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(255, 255, 255, 0.5)',
  zIndex: 2
}

export const STEP_WRAPPER_STYLE = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column' as const
}
